// frontend/src/layouts/RootLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header'; // Adjust the path if necessary
import { Box } from '@mui/material';

const RootLayout = () => {
  return (
    <>
      <Header />
      {/* Main Content Area */}
      <Box sx={{ mt: { xs: '56px', sm: '64px' } }}>
        {/* The 'mt' (margin-top) ensures content is not hidden behind the fixed Header */}
        <Outlet />
      </Box>
    </>
  );
};

export default RootLayout;
